import React from 'react';
import { Link } from 'react-router-dom';

export default function PageNotFound() {
    return (
        <div className="container-fluid">
            <div className="row justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
                <div className="col-sm-8 col-md-6 col-lg-4">
                    <div className="card text-center">
                        <div className="card-body">
                            <h1 className="display-1 text-danger">404</h1>
                            <h4 className="mb-3">Page Not Found</h4>
                            <p className="text-muted mb-4">
                                Sorry, the page you are looking for does not exist or has been moved.
                            </p>
                            <Link to="/" className="btn btn-theme">
                                <i className="ri-arrow-left-line me-2"></i>
                                Back to Dashboard
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
} 